<script setup>
defineProps({
    question: {
        type: Object,
        required: true,
    },
});
const value = defineModel({ type: [Object], required: true });
</script>

<template>
    <div class="flex flex-col gap-2">
        <label class="flex gap-1 items-center" v-for="choice in question.options.choices" :key="choice.id">
            <input
                v-model="value.choice"
                :name="`question_${question.id}`"
                :value="choice.value"
                type="radio"
                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
            />
            <span>{{ choice.text }}</span>
        </label>
    </div>
</template>
